"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// w pliku mesapi sa jeszcze mapowania ID na typ requestu
// * staticIdentifiers
// * beaconIdentifiers
// * applicationIdentifiers
var domainMap = {
    'i.wpimg.pl': 'ii',
    'j.wpimg.pl': 'ij',
    'a.wpimg.pl': 'ia',
    'b.wpimg.pl': 'ib',
    'c.wpimg.pl': 'ic',
    'd.wpimg.pl': 'id',
    'i.wp.pl': 'iw',
    'adv.wp.pl': 'ad',
    'dot.wp.pl': 'do',
    'ma.wp.pl': 'aabma',
    'dynacrems.wp.pl': 'aabdc',
    'wpkoszyk.wp.pl': 'aabko',
    'koszykrd.wp.pl': 'aabkord',
    'rek.www.wp.pl': 'rk',
    'static1.money.pl': 'ms',
    'materials-api.wp.pl': 'maw',
    'data-api.wp.pl': 'daw',
};
exports.default = domainMap;
